import { Routes } from "@angular/router";
import { AuthGuard } from "./pages/auth/services/auth.guard";
import { SelectRoleComponent } from "./pages/auth/components/select-role/select-role.component";
import { SsoEntryComponent } from "./pages/auth/components/sso-entry/sso-entry.component";

export const routes: Routes = [
  {
    path: "",
    component: SsoEntryComponent,
    pathMatch: "full",
  },
  {
    path: "auth",
    loadChildren: async () =>
      import("./pages/auth/auth.module").then((m) => m.AuthModule),
  },
  {
    path: "select-role",
    component: SelectRoleComponent,
  },
  {
    path: "error",
    loadChildren: async () =>
      import("./modules/errors/errors.module").then((m) => m.ErrorsModule),
  },
  {
    path: "",
    canActivateChild: [AuthGuard],
    loadChildren: async () =>
      import("./_metronic/layout/layout.module").then((m) => m.LayoutModule),
  },
  { path: "**", redirectTo: "error/404" },
];
